import React from 'react';

export function Stepper(props: { steps: number; currentStep: number }) {
  const step = (number: number) => (
    <li
      className="tw:flex tw:not-last:w-full tw:items-center tw:not-last:after:content-[''] tw:not-last:after:w-full tw:not-last:after:h-1 tw:not-last:after:border-b-4 tw:not-last:after:border-gray-100 tw:not-last:after:border-4 tw:not-last:after:inline-block"
      data-testid={`step-${number}`}
      key={`step-${number}`}>
      <span className="tw:sr-only">
        Step {number} of {props.steps}
      </span>
      <span className="tw:flex tw:items-center tw:justify-center tw:w-8 tw:h-8 tw:bg-gray-200 tw:font-bold tw:text-lg tw:rounded-full tw:lg:h-10 tw:lg:w-10 tw:shrink-0">
        {number}
      </span>
    </li>
  );
  const currentStep = (number: number) => (
    <li
      className="tw:flex tw:not-last:w-full tw:items-center tw:not-last:after:content-[''] tw:not-last:after:w-full tw:not-last:after:h-1 tw:not-last:after:border-b-4 tw:not-last:after:border-gray-100 tw:not-last:after:border-4 tw:not-last:after:inline-block"
      data-testid={`step-${number}`}
      key={`step-${number}`}>
      <span className="tw:sr-only">
        Step {number} of {props.steps}
      </span>
      <span className="tw:flex tw:items-center tw:justify-center tw:w-8 tw:h-8 tw:bg-primary-light tw:text-black tw:font-bold tw:border-primary tw:border-2 tw:text-lg tw:rounded-full tw:lg:h-10 tw:lg:w-10 tw:shrink-0">
        {number}
      </span>
    </li>
  );
  const completeStep = (number: number) => (
    <li
      className="tw:flex tw:not-last:w-full tw:items-center tw:text-primary tw:not-last:after:content-[''] tw:not-last:after:w-full tw:not-last:after:h-1 tw:not-last:after:border-b-4 tw:not-last:after:border-primary tw:not-last:after:border-4 tw:not-last:after:inline-block"
      data-testid={`complete-${number}`}
      key={`complete-${number}`}>
      <span className="tw:sr-only">Step {number} complete</span>
      <span className="tw:flex tw:items-center tw:justify-center tw:w-8 tw:h-8 tw:bg-primary tw:rounded-full tw:lg:h-10 tw:lg:w-10 tw:shrink-0">
        <svg
          className="tw:w-3.5 tw:h-3.5 tw:text-white tw:lg:w-4 tw:lg:h-4"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 16 12">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M1 5.917 5.724 10.5 15 1.5"
          />
        </svg>
      </span>
    </li>
  );
  return (
    <ol className="tw:flex tw:items-center tw:w-full">
      {Array.from({ length: props.steps }, (_, i) => {
        if (i + 1 < props.currentStep) {
          return completeStep(i + 1);
        } else if (i === props.currentStep - 1) {
          return currentStep(i + 1);
        } else {
          return step(i + 1);
        }
      })}
    </ol>
  );
}
